module.exports = __webpack_public_path__ + "img/mynews24-footer.3cb4c544.png";